import React, {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import Toggle from 'react-toggle';
import {Tooltip} from 'react-tippy';
import {ReactComponent as TooltipIcon} from 'assets/icons/tooltip.svg';

const ToggleSwitch = ({settings, onChange}) => {
  const intl = useIntl();
  const {
    name,
    label,
    state,
    type,
    labelFirst = false,
    trueValue = true,
    falseValue = false,
    disabled = false,
    tooltip,
  } = settings || {};

  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (type === 'toggle' && !state[name]) {
      setChecked(false);
    }
  }, [state]);

  if (!name) {
    return '';
  }

  const handleChange = (event) => {
    if (onChange && typeof onChange === 'function') {
      const {name, checked, dataset} = event.target;
      setChecked(checked ? trueValue : falseValue);
      onChange({
        target: {
          name,
          checked: checked ? trueValue : falseValue,
          dataset,
          type: 'toggle'
        }
      })
    }
  };

  return (
    <label className="react-toggle-wrapper">
      {labelFirst && <span>{intl.formatMessage({id: label})}</span>}
      <Toggle
        name={name}
        checked={checked}
        icons={false}
        onChange={handleChange}
        value={state[name || checked]}
        disabled={disabled}
      />
      {!labelFirst && <span style={{opacity: disabled ? '0.4' : ''}}>{intl.formatMessage({id: label})}</span>}
      {
        tooltip &&
        <Tooltip
          title={intl.formatMessage({id: tooltip})}
          trigger="mouseenter focus click"
          arrow={true}
          tabIndex={0}
          inertia={true}
          interactive={true}>
          <TooltipIcon/>
        </Tooltip>
      }
    </label>
  );
};

export default ToggleSwitch;
